import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AuthGuard  {
  constructor(private http: HttpClient, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.http.get('rest-api/v1/admin/task-management/admins/me').pipe(
      map(() => true),
      catchError(() => of(this.router.createUrlTree(['/admin/login']))),
    );
  }
}
